"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crmPermissions = void 0;
var enum_1 = require("../enum");
exports.crmPermissions = [enum_1.Permissions.CanCreateOwnUserType];
